import Component from 'components/pages/Faq/Faq';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  fullPage: true,
  metaData: {
    title: 'FAQ',
    description:
      'How do I earn cash with Qmee? Shop, search & take surveys. Is the app free? Yes! What’s the minimum cashout amount? There is none!',
  },
});
